import { render, staticRenderFns } from "./IssuesTab.vue?vue&type=template&id=3f90b65d&scoped=true&"
import script from "./IssuesTab.vue?vue&type=script&lang=js&"
export * from "./IssuesTab.vue?vue&type=script&lang=js&"
import style0 from "./IssuesTab.vue?vue&type=style&index=0&id=3f90b65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f90b65d",
  null
  
)

export default component.exports